import { Button, Switch, Table, TableContainer, Tbody, Td, Th, Thead, Tr, useToast, Divider, FormControl, FormLabel, Heading, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure, } from "@chakra-ui/react";
import axios from "axios";
import { useEffect, useState } from "react";
import { ChatState } from "../../../Context/ChatProvider";


const PayementTable = ({ data, name, Id, search, loading, setFetchHistoryAgain,level }) => {
	const { isOpen, onOpen, onClose } = useDisclosure()
	const [id, setId] = useState();
	const [studentId, setStudentId] = useState(Id);
	const [dateStart, setDateStart] = useState();
	const [dateEnd, setDateEnd] = useState();
	const [totaleMonth, setTotaleMonth] = useState();
	const [amount, setAmount] = useState();
	const [reduction, setReduction] = useState(0);
	const [pricePaid, setPricePaid] = useState();
	const [show, setShow] = useState(false);
	const [restPayement, setRestPayement] = useState(0);
	const [picLoading, setPicLoading] = useState(false);
	const { user } = ChatState();

	const toast = useToast();

	useEffect(() => {

        if (dateStart && !dateEnd) {
            const d = new Date(new Date(dateStart).toLocaleDateString())
            d.setMonth(d.getMonth() + 1)
            setDateEnd(d.toISOString().substring(0, 10))
        }

    }, [dateStart])

    useEffect(() => {

        if (dateStart && dateEnd) {
            setTotaleMonth(monthDiff(dateStart,dateEnd))
        }

    }, [dateStart, dateEnd])
	useEffect(() => {

        if (dateStart && dateEnd && amount && reduction!=='' && pricePaid) {
            const Totale = reduction == 0 ? (amount * totaleMonth) : ((amount * totaleMonth) - ((amount * totaleMonth) * reduction) / 100);
            const rest=(Totale-pricePaid)
            setRestPayement(rest);
        }

    }, [dateStart, dateEnd, amount, reduction, pricePaid])

    

    const monthDiff = (dateStart,dateEnd) => {
        const d1 = new Date(dateStart);
        const d2 = new Date(dateEnd);
        return (Math.max(0, (d2.getFullYear() - d1.getFullYear()) * 12 - d1.getMonth() + d2.getMonth()));
    }
    async function getLevelInfo() {
        try {

            if (level !== '') {


                const config = {
                    headers: {
                        Authorization: `Bearer ${user.token}`,
                    },
                    params: { levelName: level }
                };
                const { data } = await axios.get(`/api/level`, config)

                setAmount(data[0].price);

            }

        } catch (error) {
            toast({
                title: "Une erreur s'est produite !",
                description: "Échec du chargement des résultats de recherche",
                status: "error",
                duration: 5000,
                isClosable: true,
                position: "bottom-left",
            });
        }
    }
	const openModal = (payementInfo) => {
		setShow(true)
		//getLevelInfo();
		setId(payementInfo?payementInfo._id:'')
		setAmount(payementInfo?payementInfo.amount:'')
        setStudentId(payementInfo?payementInfo.studentId:'');
        setDateStart(payementInfo? new Date(payementInfo.dateStart).toISOString().substring(0, 10):'');
        setDateEnd(payementInfo? new Date(payementInfo.dateEnd).toISOString().substring(0, 10):'');
        setReduction(payementInfo?payementInfo.reduction:0);
        setPricePaid(payementInfo?payementInfo.pricePaid:'');
        setRestPayement(payementInfo?payementInfo.restPayement:'');
		setShow(false)
        onOpen()
		// onOpen()
	}

	async function getRestPayementByStudentId() {
		try {

			const config = {
				headers: {
					Authorization: `Bearer ${user.token}`,
				},
				params: { studentId: studentId  }
			};
			const { data } = await axios.get(`/api/payement/restPayement`, config)

		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: "Échec du chargement des résultats de recherche",
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom-left",
			});
		}

	};

	const deletePayement = async (id) => {


		try {
			const config = {
				headers: {
					"Content-type": "application/json",
					Authorization: `Bearer ${user.token}`,
				},
				params: { id: id }

			};

			await axios.delete(
				'/api/payement',
				config
			);

			toast({
				title: "Supprimé avec succès",
				status: "success",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});
			getRestPayementByStudentId()
            setFetchHistoryAgain(true);
			;
		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: error.response.data.message,
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});
		}
	}



	const updatePayement = async () => {



        if (!studentId || !dateStart || !dateEnd || !amount || reduction==='' || !pricePaid) {
			
            toast({
                title: "Veuillez remplir tous les champs",
                status: "warning",
                duration: 5000,
                isClosable: true,
                position: "bottom",
            });
            setPicLoading(false);
            return;
        }

        try {
           
          
            const config = {
                headers: {
                    "Content-type": "application/json",
                    Authorization: `Bearer ${user.token}`,
                },
            };
		
            await axios.put(
                "/api/payement",
                {
					id,
                    studentId,
                    dateStart,
                    dateEnd,
                    amount,
                    reduction,
                    pricePaid,
                    restPayement
                },
                config
            );
            toast({
                title: "Erfolgreich hinzugefügt",
                status: "success",
                duration: 5000,
                isClosable: true,
                position: "bottom",
            });

            getRestPayementByStudentId()
            setFetchHistoryAgain(true);
            onClose()
        
        } catch (error) {
            toast({
                title: "Une erreur s'est produite !",
                description: error.response.data.message,
                status: "error",
                duration: 5000,
                isClosable: true,
                position: "bottom",
            });

        }

    };



	return (

		<>
			{/* <Button ml={4} ref={finalRef}>
        I'll receive focus on close
    </Button> */}
			<Modal

				isOpen={isOpen}
				onClose={onClose}
			>
				<ModalOverlay />
				<ModalContent m='auto'>
					<ModalHeader className="bg-gray-50 shadow-md text-black text-xl"><i className="fa-solid fa-layer-group text-2xl mr-1"></i> Payement</ModalHeader>

					<ModalBody pb={6}>


						<div className="mr-4">

							{/* <FormControl mt={4}>
			<p className="text-lg font-bold">{studentId}  {studientName}</p>
			</FormControl>
			<FormControl mt={4}>
		   
				  
			</FormControl> */}
							<h2 className="text-md font-bold">Période : </h2>
							<FormControl mt={2}>
								Du : <input className="w-40 h-10 rounded-md border py-2 px-1 mr-2" type="date" name="dateStart" value={dateStart}
									onChange={(e) => setDateStart(e.target.value)} />
								A : <input className="border w-40 h-10 rounded-md py-2 px-1" type="date" name="dateEnd" value={dateEnd}
									onChange={(e) => setDateEnd(e.target.value)} />
							</FormControl>
							<FormControl width={"40"} mt={4}>
								<Input placeholder='reduction %' id='reduction' value={reduction}
									onChange={(e) => setReduction(e.target.value)} />
							</FormControl>



							<FormControl mt={4}>
								<Input placeholder='le prix payé' id='pricePaid' value={pricePaid}
									onChange={(e) => setPricePaid(e.target.value)} />
							</FormControl>

							<FormControl mt={4}>
								{dateStart && dateEnd ?
									<p className="text-base mt-1 drop-shadow-md font-bold border p-3 bg-gray-50">Totale : {amount}DH/m x {totaleMonth} mois {reduction > 0 ? ' - ' + reduction + ' %' : ""} =  {reduction == 0 ? (amount * totaleMonth) : ((amount * totaleMonth) - ((amount * totaleMonth) * reduction) / 100)} DH</p> : ""}
								<p className="text-sm mt-1 ml-2  drop-shadow-md font-bold">*Tarif Nivaux {level} est {amount} DH </p>
							</FormControl>





						</div>


					</ModalBody>

					<ModalFooter>
						<Button colorScheme='blue' mr={3}
							onClick={updatePayement}
							isLoading={picLoading}>
							Enregistrer
						</Button>
						<Button onClick={onClose}>Annuler</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>


			<TableContainer w={"full"} className='border'>
				<Table variant={"simple"} >

					<Thead>
						<Tr className="bg-gray-50 text-black">
							<Th textAlign={"center"}>Etudient</Th>
							<Th textAlign={"center"}>Periode</Th>
							<Th textAlign={"center"}>Prix</Th>
							<Th textAlign={"center"}>Reduction</Th>
							<Th textAlign={"center"}>Total</Th>
							<Th textAlign={"center"}>le prix payé</Th>
							<Th textAlign={"center"}>le prix restant</Th>
							<Th w={"24"}></Th>
						</Tr>
					</Thead>
					<Tbody >

						{data?.filter((payement) => {
							return search.toLowerCase() === ''
								? payement
								: payement.payementName.toLowerCase().includes(search.toLowerCase());
						})
							.map((payement, index) => (

								<Tr key={index} fontSize="sm">

									<Td textAlign={"center"}>{name}</Td>
									<Td textAlign={"center"}>{payement.dateStart.substring(0, 10) + ' - ' + payement.dateEnd.substring(0, 10) + ' (' + monthDiff(payement.dateStart, payement.dateEnd) + ' Mois)'}</Td>
									<Td textAlign={"center"}>{payement.amount}</Td>
									<Td textAlign={"center"}>{payement.reduction}</Td>
									<Td textAlign={"center"}>{
										(payement.reduction == 0 ? (payement.amount * monthDiff(payement.dateStart, payement.dateEnd))
											: ((payement.amount * monthDiff(payement.dateStart, payement.dateEnd)) - ((payement.amount * monthDiff(payement.dateStart, payement.dateEnd)) * payement.reduction) / 100))
									}</Td>
									<Td textAlign={"center"}>{payement.pricePaid}</Td>
									<Td textAlign={"center"}>{payement.restPayement}</Td>



									<Td >
										<Button bg='gray.50' onClick={() => { openModal(payement) }}> <i className="fa-regular fa-pen-to-square text-blue-400 mr-2"></i> Modifier</Button>
										<Button fontSize={14} ml={2} bg='gray.50' onClick={() => deletePayement(payement._id)}  ><i className="fa-solid fa-trash text-red-500"></i></Button>
									</Td>
								</Tr>

							))}
					</Tbody>


				</Table>
				<div className="w-full  flex item-center p-6">
					{loading && <i className="fa-solid fa-circle-notch animate-spin m-auto text-xl"></i>}
					{!loading && data.length === 0 && <span className="text-md text-gray-300 m-auto">Aucun résultat.</span>}
				</div>
			</TableContainer>
		</>
	);


};

export default PayementTable;
